import { render, staticRenderFns } from "./SupplierClassify.vue?vue&type=template&id=4a4c2cd9&scoped=true"
import script from "./SupplierClassify.vue?vue&type=script&lang=ts"
export * from "./SupplierClassify.vue?vue&type=script&lang=ts"
import style0 from "./SupplierClassify.vue?vue&type=style&index=0&id=4a4c2cd9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4c2cd9",
  null
  
)

export default component.exports